import { memo } from 'react';
import { List } from 'semantic-ui-react';

import { Shipping } from 'models/auction/Shipping';
import ShippingItem from './ShippingItem/ShippingItem';

interface ShippingListProps {
  shippings: Shipping[];
}

function ShippingList({ shippings }: ShippingListProps) {
  const inPersonShippings = shippings.filter(({ type }) => type === 'in_person');
  const parcelShippings = shippings.filter(({ type }) => type === 'parcel');
  const otherShippings = shippings.filter(({ type }) => type === 'other');

  return (
    <List>
      {inPersonShippings.length !== 0 && (
        <List.Item>
          <List.Icon name="caret right" />
          <List.Content>
            <b>직거래 시, 다음의 장소에서 가능합니다</b>
            <List.List>
              {inPersonShippings.map((shipping, index) => (
                <ShippingItem key={index} shipping={shipping} />
              ))}
            </List.List>
          </List.Content>
        </List.Item>
      )}
      {parcelShippings.length !== 0 && (
        <List.Item>
          <List.Icon name="caret right" />
          <List.Content>
            <b>배송 시, 다음의 배송료가 부과됩니다</b>
            <List.List>
              {parcelShippings.map((shipping, index) => (
                <ShippingItem key={index} shipping={shipping} />
              ))}
            </List.List>
          </List.Content>
        </List.Item>
      )}
      {otherShippings.length !== 0 && (
        <List.Item>
          <List.Icon name="caret right" />
          <List.Content>
            <b>다음의 거래 정보를 참고해주세요</b>
            <List.List>
              {otherShippings.map((shipping, index) => (
                <List.Item key={index} content={shipping.description} />
              ))}
            </List.List>
          </List.Content>
        </List.Item>
      )}
    </List>
  );
}

export default memo(ShippingList);
